import type {IBuilderVersion} from '../types.js';
import type {IClassicBuilderStore} from './types.js';

/**
 * Represents a frozen version of the builder at a given time.
 */
export class ClassicBuilderVersion implements IBuilderVersion {
  timestamp: Date;
  store: string;

  private storeRef: IClassicBuilderStore;

  constructor(store: IClassicBuilderStore) {
    this.storeRef = store;
    this.store = store.serialize();
    this.timestamp = new Date();
  }

  compare(version: IBuilderVersion): number {
    if (version.timestamp === this.timestamp && version.store === this.store) {
      return 0;
    }

    if (version.timestamp > this.timestamp) {
      return -1;
    }

    return 1;
  }

  clone(): IBuilderVersion {
    const clone = new ClassicBuilderVersion(this.storeRef);
    clone.timestamp = this.timestamp;
    return clone;
  }
}
